export const LESSON_VIEWER_FETCH_START = 'LESSON_VIEWER_FETCH_START';
export const LESSON_VIEWER_FETCH_SUCCESS = 'LESSON_VIEWER_FETCH_SUCCESS';
export const LESSON_VIEWER_FETCH_ERROR = 'LESSON_VIEWER_FETCH_ERROR';
export const LESSON_VIEWER_RESET = 'LESSON_VIEWER_RESET';

export const LESSON_VIEWER_NARRATION_PENDING =
  'LESSON_VIEWER_NARRATION_PENDING';
export const LESSON_VIEWER_NARRATION_PLAYING =
  'LESSON_VIEWER_NARRATION_PLAYING';
export const LESSON_VIEWER_NARRATION_COMPLETE =
  'LESSON_VIEWER_NARRATION_COMPLETE';
export const LESSON_VIEWER_NARRATION_ERROR =
  'LESSON_VIEWER_NARRATION_ERROR';
export const LESSON_VIEWER_NARRATION_RESET =
  'LESSON_VIEWER_NARRATION_RESET';

export const LESSON_VIEWER_SET_PHASE = 'LESSON_VIEWER_SET_PHASE';
export const LESSON_VIEWER_ADVANCE_TERM = 'LESSON_VIEWER_ADVANCE_TERM';
export const LESSON_VIEWER_SET_QUESTION_INDEX = 'LESSON_VIEWER_SET_QUESTION_INDEX';
export const LESSON_VIEWER_SET_LEARNING_STEP_INDEX =
  'LESSON_VIEWER_SET_LEARNING_STEP_INDEX';
export const LESSON_VIEWER_SET_WORKBOOK_EXERCISE_INDEX =
  'LESSON_VIEWER_SET_WORKBOOK_EXERCISE_INDEX';

export const LESSON_VIEWER_WORKBOOK_READY = 'LESSON_VIEWER_WORKBOOK_READY';
export const LESSON_VIEWER_WORKBOOK_DONE = 'LESSON_VIEWER_WORKBOOK_DONE';
export const LESSON_VIEWER_WORKBOOK_SUBMIT = 'LESSON_VIEWER_WORKBOOK_SUBMIT';

export const LESSON_VIEWER_KC_SUBMIT = 'LESSON_VIEWER_KC_SUBMIT';
export const LESSON_VIEWER_KC_NEXT = 'LESSON_VIEWER_KC_NEXT';
export const LESSON_VIEWER_KC_SUMMARY_DONE = 'LESSON_VIEWER_KC_SUMMARY_DONE';

export const LESSON_VIEWER_MASTERY_SUBMIT = 'LESSON_VIEWER_MASTERY_SUBMIT';
export const LESSON_VIEWER_MASTERY_NEXT = 'LESSON_VIEWER_MASTERY_NEXT';

export const LESSON_VIEWER_TOGGLE_DEV_TOOLS = 'LESSON_VIEWER_TOGGLE_DEV_TOOLS';
export const LESSON_VIEWER_DEV_JUMP = 'LESSON_VIEWER_DEV_JUMP';
export const LESSON_VIEWER_SET_TUTORIAL_VIEWED = 'LESSON_VIEWER_SET_TUTORIAL_VIEWED';
export const LESSON_VIEWER_SET_TUTOR_CHAT_OPEN = 'LESSON_VIEWER_SET_TUTOR_CHAT_OPEN';

/** Web: Unity iframe background is loading until legacy route `x` + bridge handshake (see lessonViewerUnityBridge). */
export const LESSON_VIEWER_UNITY_WORLD_LOADING_SET =
  'LESSON_VIEWER_UNITY_WORLD_LOADING_SET';
